import script from "./legend-tab.vue?vue&type=script&setup=true&lang=ts"
export * from "./legend-tab.vue?vue&type=script&setup=true&lang=ts"

import "./legend-tab.vue?vue&type=style&index=0&id=47bef3de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47bef3de"]])

export default __exports__